import { ReactEditor, useReadOnly } from 'slate-react';
import { useEditorRef, type PlateElementProps } from 'platejs/react';
import { Box } from '@mui/material';

import {
    TComponents,
    COMPONENTS,
} from 'common/components/ContentEditor/options';

interface IProps extends PlateElementProps {
    as?: TComponents;
    styles?: { [key: string]: string };
    variant?: string;
}

export const EditorComponent = ({
    as = 'div',
    children,
    attributes,
    element,
    className,
    styles,
    variant,
    ...other
}: IProps) => {
    const Component = COMPONENTS[as] || as;

    const editor = useEditorRef();
    const readOnly = useReadOnly();
    const path = ReactEditor.findPath(
        editor as unknown as ReactEditor,
        element
    );
    const lastIndex = editor.children.length - 1;
    const isLastNode = path[0] === lastIndex;
    const isRootNode = path.length === 1;

    if (
        isLastNode &&
        readOnly &&
        element.type === 'p' &&
        element.children.length === 1 &&
        'text' in element.children[0] &&
        element.children[0].text === ''
    ) {
        return null;
    }

    const editorComponent = (
        <Component
            className={!isRootNode ? className : ''}
            variant={variant}
            {...other}
        >
            {children}
        </Component>
    );

    if (isRootNode) {
        return (
            <div className={className} {...attributes}>
                <Box sx={{ mb: 2 }}>{editorComponent}</Box>
            </div>
        );
    }

    return editorComponent;
};
